import { create } from 'zustand';

export const MAGNETBOARD_PRINT_PAGE_STYLE = `
  @page {
    margin: 8mm;
  }

  html,
  body {
    height: initial !important;
    overflow: initial !important;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
    font-size: 11px;
  }

  .mb-print-screen-hidden {
    display: block !important;
    visibility: visible !important;
    position: static !important;
    left: auto !important;
    top: auto !important;
    width: auto !important;
    padding: 0 !important;
  }

  .mb-print-screen-hidden * {
    visibility: visible !important;
  }

  .mb-print-shell {
    display: block !important;
    visibility: visible !important;
    color: #000;
  }

  .mb-print-header {
    margin-bottom: 8px;
  }

  .mb-print-title {
    font-size: 16px;
    font-weight: 700;
  }

  .mb-print-subtitle {
    margin-top: 2px;
    color: #666;
    font-size: 11px;
  }

  .mb-print-header-row,
  .mb-print-schedule-row {
    break-inside: avoid;
    page-break-inside: avoid;
  }

  .mb-print-shell .mb-main-inner-box,
  .mb-print-shell .mb-inner-box {
    min-width: 0;
    font-size: 10px;
  }

  .mb-print-shell .mb-schedule-main-inner-box {
    min-width: 0;
  }

  .mb-print-shell .mb-schedule-row-name-container {
    padding: 4px;
  }

  .mb-print-shell .mb-schedule-row-name {
    font-size: 10px;
    line-height: 1.15;
  }

  .mb-print-shell .mb-schedule-row-department {
    font-size: 9px;
    line-height: 1.15;
  }

  .mb-print-shell .mb-schedule-inner-box {
    min-height: 42px;
    padding: 4px;
    background-color: #fff;
  }

  .mb-print-shell .mb-section,
  .mb-print-shell .mb-student-section,
  .mb-print-shell .mb-manual-section {
    margin: 0 0 4px 0;
    border: 1px solid #d9d9d9;
    box-shadow: none;
    cursor: default;
    break-inside: avoid;
    page-break-inside: avoid;
  }

  .mb-print-shell .mb-section-top-bar {
    min-height: 4px;
    padding: 0 4px;
  }

  .mb-print-shell .mb-section-content,
  .mb-print-shell .mb-manual-section-content {
    padding: 3px 4px 4px 4px;
  }

  .mb-print-shell .mb-section-content:hover {
    box-shadow: none;
  }

  .mb-print-shell .mb-section-name {
    font-size: 10px;
    line-height: 1.15;
    white-space: normal !important;
  }

  .mb-print-shell .mb-section-label {
    margin: 2px 0;
    padding: 0 4px;
    font-size: 9px;
    line-height: 1.15;
  }

  .mb-print-shell .mb-section-quarter-day-container,
  .mb-print-shell .mb-section-subname-container,
  .mb-print-shell .mb-section-more-info,
  .mb-print-shell .lock-section-btn,
  .mb-print-shell .mb-add-new-section {
    display: none !important;
  }
`;

const useReportsStore = create((set, get) => ({
  openReports: [],
  classroomPlacementReport: null,
  scheduleSummaryScope: null,
  printRef: null,
  printByTeacherRef: null,
  setOpenReports: (reports) => set({ openReports: reports }),
  setClassroomPlacementReport: (report) => set({ classroomPlacementReport: report }),
  setScheduleSummaryScope: (scope) => set({ scheduleSummaryScope: scope }),
  addOpenReport: (report) => {
    const report_index = get().openReports.findIndex(open_report => open_report === report);
    if(report_index === -1) {
      const newReports = [...get().openReports, report];
      set({ openReports: newReports });
    }
  },
  removeOpenReport: (report) => {
    const newReports = get().openReports.filter(open_report => open_report !== report);
    set({ openReports: newReports });
  },
  setPrintRef: (ref) => set({ printRef: ref }),
  setPrintByTeacherRef: (ref) => set({ printByTeacherRef: ref }),
}), {
  name: 'reports-store', // Nome no devtools
});
  
export default useReportsStore;

export const useReportsData = () => useReportsStore((state) => ({
  openReports: state.openReports,
  classroomPlacementReport: state.classroomPlacementReport,
  scheduleSummaryScope: state.scheduleSummaryScope,
}));

export const usePrintData = () => useReportsStore((state) => ({
  printRef: state.printRef,
  printByTeacherRef: state.printByTeacherRef,
}));

export const useReportsActions = () => useReportsStore((state) => ({
  addOpenReport: state.addOpenReport,
  removeOpenReport: state.removeOpenReport,
  setClassroomPlacementReport: state.setClassroomPlacementReport,
  setScheduleSummaryScope: state.setScheduleSummaryScope,
}));
export const usePrintActions = () => useReportsStore((state) => ({
  setPrintRef: state.setPrintRef,
  setPrintByTeacherRef: state.setPrintByTeacherRef,
}));
